import React, { useEffect, useState } from "react";
import BlockUi from "react-block-ui";
import InfiniteScroll from "react-infinite-scroll-component";

import { Container } from "@mui/material";

import EmptyError from "../EmptyError/EmptyError";
import AgentService from "../../Services/AgentService";
import PartnersSearch from "../Partners/PartnersSearch";
import FieldAgentReturnCard from "./FieldAgentReturnCard";
import AnalyticsService from "../../Services/AnalyticsService";

export default function FieldAgentClosedReturnOrders() {
  const [searchInfo, setSearchInfo] = useState("");
  const [loading, setLoading] = useState("not_started");
  const [searchKeyword, setSearchKeyword] = useState("");
  const [hasMoreOrders, setHasMoreOrders] = useState(true);
  const [returnOrdersList, setReturnOrdersList] = useState([]);
  const [currentPageCount, setCurrentPageCount] = useState(1);

  useEffect(() => {
    AnalyticsService.pushEvent(`Page Viewed`, { page: "Agent Closed Orders" });
  }, []);

  useEffect(() => {
    const returnOrdersCB = getReturnOrders();
    return () => returnOrdersCB();
  }, [searchKeyword]);

  const getReturnOrders = () => {
    setLoading("started");
    const { axiosRequest, abortController } =
      AgentService.getFieldAgentTicketOrders(
        currentPageCount,
        searchKeyword,
        "CLOSED"
      );
    axiosRequest
      .then((response) => {
        const orders = response?.data?.responseData?.orders;
        if (orders && orders.length) {
          setReturnOrdersList((prevList) => [...prevList, ...orders]);
          setCurrentPageCount(currentPageCount + 1);
          setHasMoreOrders(true);
        } else {
          setHasMoreOrders(false);
        }
        setLoading("done");
      })
      .catch((error) => {
        if (error?.message !== "canceled") {
          setLoading("done");
          setHasMoreOrders(false);
          console.error("Error getting In Progress Return Orders: ", error);
        }
      });
    return () => abortController.abort();
  };

  function initializePagination() {
    setReturnOrdersList([]);
    setCurrentPageCount(1);
    setHasMoreOrders(true);
  }

  const handleSearch = (keyword) => {
    if (keyword) {
      if (keyword?.length < 5) {
        return setSearchInfo("Type minimum 5 characters!");
      }
      setSearchInfo("");
      setSearchKeyword(keyword);
      initializePagination();
    } else {
      clearSearch();
    }
  };

  const clearSearch = () => {
    setSearchKeyword("");
    initializePagination();
  };

  return (
    <div>
      <Container maxWidth={`xl`} sx={{ pb: 1 }}>
        <PartnersSearch
          errorMessage={searchInfo}
          handleSearch={handleSearch}
          clearSearch={clearSearch}
          searchKeyword={searchKeyword}
          page={"Agent Pending Orders"}
        />
      </Container>

      <BlockUi
        tag="div"
        keepInView
        message={`Loading...`}
        blocking={loading === "started"}
        style={{ minHeight: "85vh" }}
      >
        {returnOrdersList?.length ? (
          <InfiniteScroll
            dataLength={returnOrdersList.length}
            next={getReturnOrders}
            hasMore={hasMoreOrders}
            loader={<p style={{ textAlign: "center" }}>Loading...</p>}
            style={{ padding: "10px 16px 125px 16px" }}
          >
            {returnOrdersList?.map((order) => (
              <FieldAgentReturnCard
                key={order.orderId}
                data={order}
                tabName={"Closed"}
              />
            ))}
          </InfiniteScroll>
        ) : (
          loading === "done" && (
            <EmptyError
              image="noComplaints.svg"
              text="All Orders Are Closed"
              hideBack={true}
            />
          )
        )}
      </BlockUi>
    </div>
  );
}
